import { Profession } from '@/modules/account/services/resources/types';

export enum InputStatusType {
  Default = 'default',
  Error = 'error',
  Success = 'success'
}

export enum CustomerType {
  PF = 'pf',
  PJ = 'pj'
}

export type RegulatoryUpdateSteps = {
  icon: string;
  label: string;
  subtitle?: string;
};

export enum RegulatoryUpdateNavigationAction {
  RegulatoryRegisterUpdate = 'go_to_regulatory_register_update',
  Suitability = 'go_to_suitability',
  AddressDocument = 'go_to_address_document',
  Home = 'go_to_home',
  Password = 'go_to_password',
  Success = 'go_to_success',
  Security = 'go_to_mfa',
  RegulatoryTerms = 'go_to_accept_terms',
  PersonalRegisterUpdate = 'go_to_personal_info_register_update'
}

export type RegulatoryUpdateNavigation = {
  actions: RegulatoryUpdateNavigationAction[];
  title: string;
};

export interface RegulatoryUpdateAnnouncementContentPF {
  title?: string;
  description?: string;
  steps?: RegulatoryUpdateSteps[];
  navigation?: RegulatoryUpdateNavigation;
}

export interface RegulatoryUpdateAnnouncementContentResponse {
  customerType: CustomerType;
  content?: RegulatoryUpdateAnnouncementContentPF;
}

export interface RegulatoryUpdatePersonalData {
  maritalStatus: string;
  partnerName?: string;
  partnerCpf?: string;
  partnerForeignRne?: string;
  profession: Profession;
  hasProfession: boolean;
  workOrganization?: string;
  workOrganizationCnpj?: string;
}

export interface InvestmentProfile {
  totalInvested: number;
  movableProperty: number;
  privatePension: number;
  realEstate: number;
  monthlyIncome: number;
}

export interface RegulatoryUpdateCustomerPersonalProfile {
  mobile: string;
  fullName: string;
  cpf: string;
  sex: string;
  birthDate: string;
  birthCountry?: {
    key: string;
    value: string;
  };
  birthCity: string;
  birthState: string;
  nationality: string;
  motherName: string;
  maritalStatus: string;
  partnerName: string | null;
  partnerCpf: string | null;
  partnerForeignRne: string | null;
  education: string;
  profession: string;
  professionId: string;
  hasProfession: boolean;
  workOrganization: string;
  workOrganizationCnpj: string;
  isExposed: boolean;
}

export interface RegulatoryUpdateCustomerAddress {
  zipcode: string;
  street: string;
  neighborhood: string;
  number: string;
  city: string;
  state: string;
  complement: string | null;
}

export interface RegulatoryUpdateCustomerInvestmentProfile {
  monthlyIncome: number;
  totalInvested: number;
  movableProperty: number;
  realEstate: number;
  privatePension: number;
  isProfessionalInvestor: boolean;
  isQualifiedInvestor: boolean;
}

export interface RegulatoryUpdateCustomerInfo {
  personalProfile: RegulatoryUpdateCustomerPersonalProfile;
  address: RegulatoryUpdateCustomerAddress;
  investmentProfile: RegulatoryUpdateCustomerInvestmentProfile;
  usPerson?: RegulatoryUpdateCustomerUsPerson | null;
  taxResidence?: RegulatoryUpdateCustomerTaxResidence | null;
}

export interface Country {
  label: string;
  value: string;
}

export interface RegulatoryUpdateCustomerUsPerson {
  itin: string;
  reasonOfAbsence: string;
}

export interface RegulatoryUpdateCustomerTaxResidence {
  country: string;
  nif: string;
  reasonOfAbsence: string;
}
